import { api } from './index';

import type {
  ExternalCalendarEventsResponse,
  GetExternalEventsArg,
} from '@/types/calendar';

// MEN-4160: coach external/personal calendar events for the Schedule page.
// Backed by the Rails proxy GET /api/v1/calendar/external_events, which fans
// out to the Moments calendar-events RPC. Only Week/Month views fetch these.
export const calendarApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExternalEvents: builder.query<
      ExternalCalendarEventsResponse,
      GetExternalEventsArg
    >({
      query: ({ coachId, start, end, viewerTimezone }) => ({
        method: 'GET',
        params: {
          end,
          start,
          viewer_timezone: viewerTimezone,
          ...(coachId ? { coach_id: coachId } : {}),
        },
        url: '/calendar/external_events',
      }),
    }),
  }),
});

export const { useGetExternalEventsQuery } = calendarApi;
